// Module
var code = "<div ng-controller=\"overviewStackedBarController as ctrl\">\n    <vue-component\n        ng-if=\"ctrl.groups.length\"\n        name=\"ReportsOverviewStackedBar\"\n        v-props-average=\"ctrl.avg\"\n        v-props-groups=\"ctrl.groups\"\n        v-props-show-percent=\"ctrl.showPercent\"\n    ></vue-component>\n</div>\n";
// Exports
module.exports = code;